module.exports = __webpack_public_path__ + "img/room.682549d8.svg";